module.exports = __webpack_public_path__ + "static/img/illustration.60666ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/register/illustration.png
// module id = 698
// module chunks = 12